module.exports = __webpack_public_path__ + "img/Betting_text03_betnotbet.a8bb4053.png";